import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { VictoryFlagIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core/react/i18n';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useDeclareVictoryLink } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { useIsMobile } from '../../../../../../hooks/useIsMobile';

export const ReachedYourGoal: React.FC = () => {
	const {
		data: { declareVictoryLink },
		actions: { onDeclareVictoryClick },
	} = useDeclareVictoryLink();

	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const isMobile = useIsMobile();

	if (petition.status !== 'PUBLISHED') {
		return null;
	}

	return (
		<div className="bg-background-raised mt-0 flex w-full flex-auto flex-row flex-wrap items-center justify-between rounded-lg p-4 md:gap-2 md:bg-transparent md:p-0">
			<div className="flex items-center gap-2">
				<div className="hidden h-8 w-8 items-center justify-center md:flex">
					<VictoryFlagIcon className="text-icon-weaker" />
				</div>
				<div className="flex h-8 items-center">
					<Text>
						<Translate value="corgi.petition.starter_dashboard.petition_overview.reached_your_goal.ask" />
					</Text>
				</div>
			</div>
			<Button
				className={cn({ 'py-2': isMobile, 'p-0': !isMobile })}
				as="a"
				href={declareVictoryLink}
				variant={isMobile ? 'secondary-solid' : 'tertiary'}
				onClick={onDeclareVictoryClick}
				size="x-small"
				data-qa="petition-overview-declare-victory-cta"
				data-testid="petition-overview-declare-victory-cta"
			>
				<Text size="small" fontWeight="bold" className="leading-5">
					<Translate value="corgi.petition.starter_dashboard.petition_overview.reached_your_goal.cta" />
				</Text>
			</Button>
		</div>
	);
};
